<template>
  <div class="backdrop-carousel" v-if="index != null">
    <button @click="closeGallery" class="close-gallery-button">X</button>
    <div class="carousel-container">
      <v-carousel :continuous="true" height="100%" show-arrows-on-hover hide-delimiters>
        <v-carousel-item
          v-for="(img, i) in this.data.Pictures"
          :key="i"
          reverse-transition="slide-x-reverse-transition"
          transition="slide-x-transition"
        >
          <img :src="img.Src" class="image" />
        </v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>
<script>
export default {
  props: ["index", "data"],
  methods: {
    closeGallery() {
      this.$emit("closeGallery");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../../scss/global.scss";

.backdrop-carousel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 1200;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  .close-gallery-button {
    position: absolute;
    top: 1rem;
    right: 1.3rem;
    width: 3rem;
    height: 3rem;
    background-color: transparent;
    border: 6px solid #fff;
    border-radius: 50%;
    color: #fff;
    font-weight: 800;
    font-size: 1.2rem;
    cursor: pointer;
  }
  .carousel-container {
    width: 22rem;
    height: 14.7rem;
    .image {
      width: 100%;
      height: 100%;
    }
    div {
      &.v-carousel__controls {
        display: none;
      }
    }
  }
}

@media (min-width: 43rem) and (min-height: 25rem) {
  .backdrop-carousel {
    .carousel-container {
      width: 38rem;
      height: 25rem;
    }
  }
}

@media (min-width: $min-width-extended) and (min-height: 33rem) {
  .backdrop-carousel {
    .carousel-container {
      width: 50rem;
      height: 33rem;
    }
  }
}
</style>